import { useState } from 'react';
import Axios from 'axios';
import { useAppSettings } from '../hooks/useAppSettings';

interface DeleteFileParams {
    category: string;
    fileName: string;
}

export const useDeleteFile = () => {
    const { settings: appSettings } = useAppSettings();
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState<string | null>(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    const deleteFile = async ({ category, fileName }: DeleteFileParams): Promise<void> => {
        if (!appSettings?.api) {
            throw new Error('API settings not available');
        }

        setIsDeleting(true);
        setDeleteError(null);
        setDeleteSuccess(false);

        try {
            const params = new URLSearchParams({
                category,
                fileName,
            });

            // Use Axios so the MSAL interceptor acquires a fresh token automatically
            await Axios.delete(`${appSettings.api}DeleteFile?${params.toString()}`);

            setDeleteSuccess(true);
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || 'Failed to delete file';
            setDeleteError(message);
            throw new Error(`Delete file failed (${error.response?.status ?? 'unknown'}): ${message}`);
        } finally {
            setIsDeleting(false);
        }
    };

    const clearMessages = () => {
        setDeleteError(null);
        setDeleteSuccess(false);
    };

    return {
        deleteFile,
        isDeleting,
        deleteError,
        deleteSuccess,
        clearMessages,
    };
};
